const growthbookMock = (_, inject) => {
  inject('growthbook', {
    isFeatureOn: () => false,
    getFeatureValue: (_, fallback) => fallback
  });
};
export default growthbookMock;